import ActionButton from 'components/ActionButton';
import ToggleSwitch from 'components/ToggleSwitch';
import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { fetchHomePageCollection, toggleActiveStatusForHomePageCollection } from 'services/api/homePageCollection';
import { DATE_FORMATS, formatDate, showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import _ from 'lodash';
import CustomLink from 'components/TableLink';

const HomePageCollections = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [activeLoading, setActiveLoading] = useState<string>('');
  const [data, setData] = useState<Record<string, any>[]>([]);

  const fetchHomePageCollections = async () => {
    setLoading(true);
    try {
      const response = await fetchHomePageCollection();
      setData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHomePageCollections();
  }, []);

  const toggleCollectionActive = async (id: string, active: boolean) => {
    setActiveLoading(id);
    try {
      const response = (await toggleActiveStatusForHomePageCollection(id)).toJSON();
      const index = _.findIndex(data, item => item.objectId === id);
      const collection = _.cloneDeep(data);
      collection[index] = response;
      setData(collection);
      showSuccess(`Collection marked ${active ? 'INACTIVE' : 'ACTIVE'} successfully`);
    } catch(e) {
      showError(e);
    } finally {
      setActiveLoading('');
    }
  };

  const columns = useMemo(() => [
    {
      name: 'Collection ID',
      selector: 'objectId',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row.objectId}
          linkTo={`/home-page-collections/${row.objectId}`}
        />
      ),
    },
    {
      name: 'Created At',
      selector: 'createdAt',
      format: row => formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
    },
    {
      name: 'Title',
      selector: 'title',
    },
    {
      name: 'Component Name',
      selector: 'componentName',
    },
    {
      name: 'Cloud Function Name',
      selector: 'cloudFunctionName',
    },
    {
      name: 'Active',
      selector: 'active',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <ToggleSwitch
          switchLabel={''}
          disabled={activeLoading === row.objectId}
          checked={row.active}
          onChange={() => toggleCollectionActive(row.objectId, row.active)}
        />
      ),
    },
  ], [activeLoading, data]);
  
  const getDataTable = () => (
    <div>
      <DataTable
        noHeader
        data={data}
        columns={columns}
        customStyles={tableStyles}
        loading={loading}
      />
    </div>
  );

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>Home Page Collections</div>
      <ActionButton
        text={<>Collection <span>+</span></>}
        active={true}
        isLoading={false}
        onClick={() => props.history.push('/home-page-collections/collection/create')}
      />
    </div>
  );
  
  return (
    <div className={styles['']}>
      {getHeader()}
      {getDataTable()}
    </div>
  );
};

export default HomePageCollections;